import styles from './EncounterTemplateOverviewPanel.module.scss';
import { RichTextArea, RichTextAreaContext } from '@app/ui';
import { Button, Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { EncounterTemplate } from '@app/medical-record/api';
import { useEffect, useRef } from 'react';
import classNames from 'classnames';

interface Props {
  template: EncounterTemplate;
  title?: React.ReactNode;
  onApply?: (template: EncounterTemplate) => void;
  disabledApplyBtn?: boolean;
  className?: string;
}

export function EncounterTemplateOverviewContent(props: Props) {
  const { template, disabledApplyBtn, onApply, title, className } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'encounters.templates.modal' });

  const editorRef = useRef<RichTextAreaContext>({
    ref: { current: null },
    editor: null!,
  });

  useEffect(() => {
    if (editorRef.current?.editor) {
      const { editor } = editorRef.current;
      editor.children = template.note ?? [];
      editor.onChange();
    }
  }, [template.note]);

  return (
    <div className={classNames(className, 'flex flex-col h-full')}>
      {title}
      <div className="flex-grow overflow-auto">
        <RichTextArea
          readonly
          className={styles.richTextArea}
          control={editorRef}
          initialValue={template.note}
        />
      </div>
      <Space direction="horizontal" className="flex-shrink-0 p-3 justify-end">
        {onApply && (
          <Tooltip key="apply" title={disabledApplyBtn && t('disabledApplyHint')}>
            <Button disabled={disabledApplyBtn} type="primary" onClick={() => onApply(template)}>
              {t('apply')}
            </Button>
          </Tooltip>
        )}
      </Space>
    </div>
  );
}
